import DropdownMain from './dropdown-main.js';

const dropdown = new DropdownMain(document.querySelectorAll('.js-dropdown'));
